import React, { useEffect } from 'react';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import './TableComponent.scss';
import './RowComponent.scss';
import utils from 'pages/ScheduleCalendar/duck/utils';
import service from 'pages/ScheduleCalendar/duck/service';
import timeUtil from 'pages/ScheduleCalendar/duck/timeUtil';
import 'stylesheets/fonts.scss';

const AggregationType = {
  Scheduled: 'Scheduled',
  OpenShift: 'OpenShift',
  VTO: 'VTO',
};

class HoursRowComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      totalHoursType: AggregationType.Scheduled,
      isDropdownOpen: false,
    };
  }

  selectAggregationType = (type) => {
    this.setState({totalHoursType: type, isDropdownOpen: false})
  }

  toggleDropdown = () => {
    this.setState(prevState => ({ isDropdownOpen: !prevState.isDropdownOpen }), () => {
      if (this.state.isDropdownOpen) {
        this.checkDropdownPosition();
      }
    })
  }

  closeDropdown = () => {
    this.setState({ isDropdownOpen: false })
  }

  componentDidMount() {
    // Add click outside listener
    document.addEventListener('click', this.handleClickOutside);
  }

  componentWillUnmount() {
    // Remove click outside listener
    document.removeEventListener('click', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    const dropdownContainer = event.target.closest('.custom-dropdown');
    if (!dropdownContainer && this.state.isDropdownOpen) {
      this.closeDropdown();
    }
  }

  checkDropdownPosition = () => {
    setTimeout(() => {
      const dropdownMenu = document.querySelector('.custom-dropdown-menu');
      if (dropdownMenu) {
        const rect = dropdownMenu.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        
        // If dropdown would be cut off at bottom, position it above
        if (rect.bottom > viewportHeight - 20) {
          dropdownMenu.classList.add('dropdown-above');
        } else {
          dropdownMenu.classList.remove('dropdown-above');
        }
      }
    }, 10);
  }

  hoursTotalSection = (topLabel, bottomLabel ) => {
    return <div className='left-group'>
              <label className='total-text ff-semibold fs12'>{topLabel}</label>
              <label className='user-count ff-regular fs12'>{bottomLabel}</label>
          </div>
  }

  scheduledHoursTotalSection = (results, userCount) => {
    return this.hoursTotalSection('Total Scheduled', `${results["WeekTotal"].toFixed(2)} hours • ${userCount} assigned`)
  }

  openShiftHoursTotalSection = (results) => {
    return this.hoursTotalSection('Total Open Shifts', `${results["WeekTotalHours"].toFixed(2)} hours • ${results["WeekTotalSlots"]} shifts`)
  }

  vtoHoursTotalSection = (results) => {
    return this.hoursTotalSection('Total VTOs', `${results["WeekTotalHours"].toFixed(2)} hours • ${results["WeekTotalSlots"]} shifts`)
  }

  weekdayCell = (itemCount, hours) => {
    return <div style={{ display: 'flex', justifyContent: 'space-between', padding: '20px 8px' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                  <img alt="User icon" src="/icons/user-avatar.svg" style={{ marginRight: '8px', alignSelf: 'center' }} />
                  <div className='labor-hours-num'>{itemCount}</div>
              </div>
              <div className='labor-hours-num'>{hours}</div>
          </div>
  }

  scheduledWeekdayCell = (results, day) => {
    return this.weekdayCell(results[day].uniqueUsers.size,  results[day].totalHours.toFixed(2) + ' h')
  }

  openShiftWeekdayCell = (results, day) => {
    return this.weekdayCell(results[day].totalSlots,  results[day].totalHours.toFixed(2) + ' h')
  }

  vtoWeekdayCell = (results, day) => {
    return this.weekdayCell(results[day].totalSlots,  results[day].totalHours.toFixed(2) + ' h')
  }

  render() {
    const {scheduledUserCount, scheduledResult, openShiftResult, shouldShowOpenShiftUI, locationData, vtoResult, shouldShowVTOUI } = this.props;
    const {totalHoursType, isDropdownOpen} = this.state;
    const weekdays =  timeUtil.daysOfTheWeek(locationData) 

    const showScheduledHours = ( totalHoursType == AggregationType.Scheduled )
    const showOpenShiftHours = ( totalHoursType == AggregationType.OpenShift ) 
    const showVTOHours = ( totalHoursType == AggregationType.VTO ) 

    return (
      <tr className="calendar-total-row">
        <td className="total-hour-cell">
            <div className="custom-dropdown">
              <button 
                className='down-button' 
                onClick={this.toggleDropdown}
              >  

                {showScheduledHours == true && this.scheduledHoursTotalSection(scheduledResult, scheduledUserCount) }
                {showOpenShiftHours == true && this.openShiftHoursTotalSection(openShiftResult) }
                {showVTOHours == true && this.vtoHoursTotalSection(vtoResult) }

                {shouldShowOpenShiftUI && <div className='cta-right-group'> <img src='/icons/down-arrow.svg'/> </div> }

              </button> 
              
              {isDropdownOpen && (
                <ul className="custom-dropdown-menu total-types">
                  <li onClick={() => this.selectAggregationType(AggregationType.Scheduled)}>
                    <a className="dropdown-item">Total Scheduled</a>
                  </li>
                  {shouldShowOpenShiftUI && (
                    <li onClick={() => this.selectAggregationType(AggregationType.OpenShift)}>
                      <a className="dropdown-item">Total Open Shifts</a>
                    </li>
                  )}
                  {shouldShowVTOUI && (
                    <li onClick={() => this.selectAggregationType(AggregationType.VTO)}>
                      <a className="dropdown-item">Total VTOs</a>
                    </li>
                  )}
                </ul>
              )}
            </div>
        </td>

        {weekdays.map(day => (
          <td key={day} className='shift-row__day-cell middle-align'>
            {showScheduledHours == true && this.scheduledWeekdayCell(scheduledResult, day)}
            {showOpenShiftHours == true && this.openShiftWeekdayCell(openShiftResult, day)}
            {showVTOHours == true && this.vtoWeekdayCell(vtoResult, day)}
          </td>
        ))}
      </tr>
    );
  }
}

export default injectIntl(HoursRowComponent);